import React from 'react';
import { ItemDotBlueSmallComponent } from '../../ItemDotBlueSmall';
import ItemWithTooltip from './ItemWithTooltip';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

export default function DotBlueSmallItem({
  item,
  isSimple,
  isExpanded,
}: Props) {
  return (
    <ItemWithTooltip item={item}>
      <ItemDotBlueSmallComponent
        item={item}
        isSimple={isSimple}
        isExpanded={isExpanded}
      />
    </ItemWithTooltip>
  );
}
